import { useEffect } from "react"
import { toast } from "sonner"
import { authApi } from "@/api/client/auth"

export function SignoutPage() {
  const { mutateAsync: signOut } = authApi.useSignOut({
    onSuccess: () => {
      toast.success("サインアウトしました。")
      setTimeout(() => {
        window.location.href = "/signin"
      }, 1000)
    },
  })

  useEffect(() => {
    const signOutAsync = async () => {
      await signOut()
    }
    signOutAsync()
  }, [signOut])

  return <div>サインアウト中...</div>
}
